import { withInstall } from '@ll-plus/utils'

import Radio from './src/radio.vue'
import RadioButton from './src/radio-button.vue'
import RadioGroup from './src/radio-group.vue'

export const LlRadio = withInstall(Radio)
export const LlRadioButton = withInstall(RadioButton)
export const LlRadioGroup = withInstall(RadioGroup)
// export default LlRadio
export * from './src/radio'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlRadio: typeof Radio
    LlRadioButton: typeof RadioButton
    LlRadioGroup: typeof RadioGroup
  }
}
